import { render, staticRenderFns } from "./ViForgotPassword.vue?vue&type=template&id=b993b28a&scoped=true"
import script from "./ViForgotPassword.vue?vue&type=script&lang=js"
export * from "./ViForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ViForgotPassword.vue?vue&type=style&index=0&id=b993b28a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b993b28a",
  null
  
)

export default component.exports